export default [
  {
    label: 'アライアンス名',
    key: 'search_agent',
  },
  {
    label: 'メールアドレス',
    key: 'search_email',
  },
  {
    label: 'ユーザ名',
    key: 'search_name',
  },
]
